import React from 'react'
import Wave from 'react-wavify';
import softDev1 from '../../Image/softDev1.png';
import softDev2 from '../../Image/softDev2.png';
import softDev3 from '../../Image/softDev3.png';
import softDev4 from '../../Image/softDev4.png';
import aboutHome1 from '../../Image/aboutHome1.png'
import aboutHome2 from '../../Image/aboutHome2.png'
const SoftDev = () => {
    const softDev = [
        { Image: softDev1, title: 'Discover', description: 'We shape brands through exploration, applying in-depth research to challenge assumptions at every turn.' },
        { Image: softDev2, title: 'Design', description: 'We create brands through exploration, applying in-depth research to challenge assumptions at every turn.' },
        { Image: softDev3, title: 'Build', description: 'We strive the increment by using lastest technology, creating work easy by doing smart work in efficient time period.' },
        { Image: softDev4, title: 'Deliver', description: 'By embracing iteration, we foster innovation, adaptability, and efficiency in everything we do.' },
    ]
    return (
        <div className='overflow-hidden relative'>
              <img src={aboutHome1} alt='image1' className='absolute top-0 hidden xl:block  left-[-2%] h-full z-[0]'></img>
              <img src={aboutHome2} alt='image2' className='absolute lg:top-[30%] hidden xl:block top-[0px] right-[0%] h-full z-[0]'></img>
            <Wave fill='#FFF' paused={false} style={{ display: 'flex' }} options={{ height: 20, amplitude: 20, speed: 0.3, points: 5 }} className='relative min-w-[1920px] h-[28px] bg-[#F6F6F6]' />
            <div className='py-5 relative z-[10]'>
                <div className='container py-8'>
                    <div className='text-center  m-auto lg:w-[60%] w-[100%] px-5'>
                        <div className='flex justify-center flex-wrap'>
                            <h1 className='uppercase text-2xl  sm:text-3xl 2xl:text-[40px] font-bold text-[#141414]  leading-[30px] 2xl:leading-[60px]'>OWE SIMPLIFY THE</h1>
                            <h1 className='uppercase text-2xl  sm:text-3xl 2xl:text-[40px] font-bold text-theme_dark  leading-[30px] 2xl:leading-[60px] ps-2'> SOFTWARE   </h1>
                            <h1 className='uppercase text-2xl  sm:text-3xl 2xl:text-[40px] font-bold text-theme_dark  leading-[30px] 2xl:leading-[60px] ps-2'>DEVELOPMENT</h1>
                            <h1 className='uppercase text-2xl  sm:text-3xl 2xl:text-[40px] font-bold  leading-[30px] 2xl:leading-[60px] ps-2'> PROCESS</h1>
                        </div>
                    </div>
                </div>
                <div className='container flex justify-center flex-wrap'>
                    {softDev?.map((item, ind) => {
                        return (
                            ind % 2 === 1 ? (
                                <div className={`w-full 2xl:p-10 sm:p-8  py-4 px-0 relative sp_card_main flex md:flex-nowrap flex-wrap justify-center md:gap-8 gap-4 items-center flex-col-reverse md:flex-row`}>
                                    <div className='md:w-[50%] w-[100%] md:text-end text-center'>
                                        <h1 className='uppercase text-xl  sm:text-2xl 2xl:text-3xl font-bold text-[#141414]  leading-[30px] 2xl:leading-[66px]'>{item.title}</h1>
                                        <div className='font-semibold  text-xl  sm:text-xl 2xl:text-2xl 2xl:w-[80%] w-full ms-auto   mb-[10px]   py-3'>
                                            <h5 className='text-[#000000B2]  xl:text-xl md:text-lg text-sm' >{item.description}</h5>
                                        </div>
                                    </div>
                                    <div className='md:w-[50%] w-[100%] ' data-aos="fade-left">
                                        <div className='md:w-[300px] md:h-[220px] w-[150px] h-[120px] shadow-purple-md rounded-[5%] flex items-center justify-center m-auto md:m-0'>
                                            <img src={item.Image} className='md:w-[120px] md:h-[120px] w-[70px] h-[70px]' alt={item.title}></img>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div className={`w-full 2xl:p-10 sm:p-8 py-4 px-0 relative sp_card_main flex md:flex-nowrap flex-wrap justify-center gap-8 items-center flex-row`}>
                                    <div className='md:w-[50%] w-[100%]' data-aos="fade-right">
                                        <div className='md:w-[300px] md:h-[220px] w-[150px] h-[120px] shadow-purple-md md:float-end  rounded-[5%] flex items-center justify-center m-auto'>
                                            <img src={item.Image} className='md:w-[120px] md:h-[120px] w-[70px] h-[70px]'  alt={item.title}></img>
                                        </div>
                                    </div>
                                    <div className='md:w-[50%] w-[100%] md:text-start text-center'>
                                        <h1 className='uppercase text-xl  sm:text-2xl 2xl:text-3xl font-bold text-[#141414]  leading-[30px] 2xl:leading-[66px]'>{item.title}</h1>
                                        <div className='font-semibold  text-xl  sm:text-xl 2xl:text-2xl w-[80%] 2xl:w-[80%] w-full mb-[10px] py-3'>
                                            <h5 className='text-[#000000B2]  xl:text-xl md:text-lg text-sm'>{item.description}</h5>
                                        </div>
                                    </div>
                                </div>
                            )

                        )
                    })}
                </div>
            </div>
        </div>
    )
}

export default SoftDev;
